import React from "react";

export const MultistepIcon = ({
  icon,
  label,
  size,
  gap,
  masterColor = "black", // will use this color unless overwritten by others
  iconColor = "black",
  borderColor = "black", // circle border color
  color = "inherit", //label color
}) => {
  return (
    <div
      style={{
        position: "relative",
        display: "grid",
        placeContent: "center",
        borderRadius: "100%",
        border: `2px solid ${borderColor ?? masterColor}`,
        padding: "10px",
        margin: "10px",
        width: size,
        height: size,
        aspectRatio: "1/1",
      }}
    >
      {icon}
      <div
        style={{
          position: "absolute",
          bottom: `-${gap}px`,
          left: "50%",
          transform: "translateX(-50%)",
          whiteSpace: "nowrap",
          color: color ?? masterColor,
        }}
      >
        {label}
      </div>
    </div>
  );
};
